import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { FormattedMessage } from "react-intl";

type Props = {};

const TeamMembers = ({ team_members }: any) => {
  // console.log(team_members, "awwwwwwwwwwwwwwwwwwwwwwwwwww");
  // const BestTeams = team_members
  //   .filter((e: any) => e.appointments_count > 0)
  //   .sort((a: any, b: any) => b.appointments_count - a.appointments_count);
  // console.log(BestTeams, "BestTeamsBestTeamsBestTeams");

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-6 text-center max-lg:overflow-auto">
      <h6 className="text-base font-semibold">
        <FormattedMessage id="top_team_members_this_month_title" />
      </h6>
      <div className="flex items-center w-full justify-evenly">
        {team_members?.map((member: any, i: number) => {
          return (
            <div className="flex flex-col items-center justify-center gap-2 py-6 text-xs">
              <Avatar
                icon={<UserOutlined style={{ fontSize: "20px" }} />}
                className="bg-[#00086d] max-w-[48px] max-h-[48px] border-solid border-color-primary border-[1px]"
                size="small"
                src={member?.media ? <img src={member?.media} alt="" /> : null}
              />
              <span className="text-sm font-semibold text-color-primary">
                {member?.name || member?.name?.name}
              </span>
              <div className="grid gap-1">
                <span className="mb-1 text-color-gray">{member?.title}</span>
                <span className="font-semibold text-black">
                  {member?.appointment_packages_count +
                    member?.appointment_services_count}{" "}
                  <FormattedMessage id="appointment_date" />
                </span>
              </div>
              {/* <span className="font-medium text-green-300 h-fit ">
                {percent}%
              </span> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TeamMembers;
